import React, { useState, useEffect } from 'react';

function formatCountdown(totalSeconds) {
    if (totalSeconds <= 0) return null;
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    if (hours >= 1) {
        return `${hours}h ${minutes}m`;
    }
    return `${minutes}m`;
}

export function LockCountdown({ lockStart, lockEnd }) {
    const [, setTick] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => setTick(t => t + 1), 1000);
        return () => clearInterval(interval);
    }, []);

    if (!lockStart || !lockEnd) return null;

    const now = new Date();
    const start = new Date(lockStart);
    const end = new Date(lockEnd);

    const eightHoursBefore = new Date(start.getTime() - 8 * 60 * 60 * 1000);

    if (now < eightHoursBefore || now >= end) return null;

    if (now >= start && now < end) {
        const secondsUntilEnd = Math.floor((end - now) / 1000);
        const formatted = formatCountdown(secondsUntilEnd);
        return (
            <span style={{ marginLeft: '8px' }}>
                {'\u{1F513}'} Disponible en {formatted}
            </span>
        );
    }

    const secondsUntilLock = Math.floor((start - now) / 1000);
    const formatted = formatCountdown(secondsUntilLock);
    return (
        <span style={{ marginLeft: '8px' }}>
            {'\u{1F512}'} Se bloquea en {formatted}
        </span>
    );
}
